export type PresentationChatContext = {
  clientName: string;
  tenantId: string;
  orderId: string;
  eventType: string;
  totalBudget?: number;
  currentProducts: string[];
};

type EventTypeEntity = {
  event_type_id?: string;
  event_type?: string;
};

type PresentationChatItem = {
  item_name?: string;
  parent_type?: string;
  option_item_id?: string | null;
};

type BuildPresentationChatContextArgs = {
  order: {
    order_id: string;
    tenant_id?: string;
    client_name?: string;
  };
  project: {
    event_type_id?: string;
    total_budget?: string | number | null;
  };
  eventTypes?: Record<string, EventTypeEntity> | null;
  items?: PresentationChatItem[] | Record<string, PresentationChatItem> | null;
};

export function buildPresentationChatContext({
  order,
  project,
  eventTypes,
  items,
}: BuildPresentationChatContextArgs): PresentationChatContext {
  const eventTypeId = project.event_type_id ?? '';
  const eventTypeLabel = eventTypes?.[eventTypeId]?.event_type?.trim();
  const eventType = eventTypeLabel || eventTypeId;

  const totalBudgetRaw = project.total_budget;
  const totalBudget =
    totalBudgetRaw === null || totalBudgetRaw === undefined || totalBudgetRaw === ''
      ? undefined
      : Number(totalBudgetRaw);

  const itemList = Array.isArray(items)
    ? items
    : Object.values(items ?? {});

  const currentProducts = itemList
    .filter((item) => item.parent_type === 'OPTION')
    .map((item) => item.item_name ?? '')
    .filter((name) => name.length > 0);

  return {
    clientName: order.client_name ?? '',
    tenantId: order.tenant_id ?? '',
    orderId: order.order_id,
    eventType,
    totalBudget: Number.isFinite(totalBudget) ? totalBudget : undefined,
    currentProducts,
  };
}
